import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select-legacy';

const NewItemField = ({ options, onCancel, onSave }) => {
  const [value, setValue] = useState(null);

  return (
    <>
      <Select
        name='sp-cohort-select'
        className={'o-select o-select--optgroup u-flex-1'}
        multi={false}
        options={options}
        value={value}
        onChange={setValue}
        simpleValue={true}
      />
      <b className='cs-txt-link--sp-blue save' onClick={() => {
        onSave(value)
        onCancel()
      }}>
        Save&nbsp;
        <i className='fa fa-floppy-o'></i>
      </b>
      <b className='cs-txt-link--sp-red delete' onClick={onCancel}>
        Cancel&nbsp;
        <i className='fa fa-ban'></i>
      </b>
    </>
  )
}

NewItemField.propTypes = {
  options: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

const AccessGroupList = ({ title, items, allItems, deleteFunction, addFunction, subTitle }) => {
  const [newItems, setNewItems] = useState([]);

  return (
    <section>
      <p>
        <b>{title}</b>
        <span>{subTitle}</span>
      </p>
      {(items + newItems).length === 0 ? (
        <p>No {title.toLowerCase()}</p>
      ) : (
        <>
          <ul className='o-organizaion-access'>
            {items.map((item) => (
              <li key={item.id}>
                <div className='u-flex u-flex-center'>
                  <span className='u-flex-1'>{item.name}</span>
                  <b className='cs-txt-link--sp-red delete' onClick={() => {
                    deleteFunction(item.id)
                  }}>
                    <i className='fa fa-trash'></i>&nbsp;Delete
                  </b>
                </div>
              </li>
            ))}
            {newItems.map((item) => (
              <li key={item.id}>
                <div className='u-flex u-flex-center'>
                  <NewItemField
                    options={allItems}
                    onCancel={() => {
                      setNewItems(newItems.filter((i) => i.id !== item.id))
                    }}
                    onSave={(value) => {
                      addFunction(value)
                    }} />
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
      <p>
        <a className='o-sp-button o-sp-button--update o-sp-button--primary' onClick={() => {
          setNewItems([...newItems, { id: Math.random(), name: '', is_new: true }])
        }}>
          New {title.slice(0, -1)}
        </a>
      </p>
      <br />
    </section>
  )
}

AccessGroupList.propTypes = {
  subTitle: PropTypes.node,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  allItems: PropTypes.array.isRequired,
  deleteFunction: PropTypes.func.isRequired,
  addFunction: PropTypes.func.isRequired,
}

export default AccessGroupList;
